// TODO: Delete or revamp this file when upgrading to Vue 3
import { BVConfigPlugin } from 'bootstrap-vue';
import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';

Vue.config.productionTip = false;

// Global BootstrapVue settings (https://bootstrap-vue.org/docs/reference/settings)
Vue.use(BVConfigPlugin, {

});

// You should never install Vue Router on the Vue base constructor in tests
// https://vue-test-utils.vuejs.org/guides/#using-with-vue-router
if (process.env.NODE_ENV !== 'test') {
  Vue.use(VueRouter);
}

Vue.use(Vuex);
